<app-modal
  [modalTitle]="modalTitle"
  [modalTitleCode]="modalTitleCode"
  [modalIcon]="modalIcon"
  [height]="height"
  [width]="width"
  (modalClose)="onModalClose()"
>
  <ng-content></ng-content>
  <button class="modal-button" [disabled]="disableButtons()" (click)="onModalOk()">{{ okText }}</button>
</app-modal>
